// src/components/pages/Produto/tabs/EmbalagensTab.jsx
import React from 'react';
import { ThemeProvider } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, Button, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import formStyles from '../../../form/Form.module.css';

import SelectEmpresa from '../../../form/SelectEmpresa';
import Select from '../../../form/Select';
import Input from '../../../form/Input';
import Checkbox from '../../../form/Checkbox';

import { podeEditarItem, podeCancelarItem, podeImprimirItem } from '../../../../hooks/usePermisionMRT';

const EmbalagensTabPanel = ({
    theme,
    module,
    //parametros
    profile,

    // MRT shared state (do Form)
    mrt,
}) => {
    const { items, rowCount, isLoading, isRefetching, isError, OptionsEmpresa, OptionsEmbalagem, novaEmbalagem, isDisabled } =
        module.state;
    const {
        change: onChange,
        focus: onFocus,
        blur: onBlur,
        setNovaEmbalagem,
        limpar,
        submit,
        handleEditarOuDeletar,
    } = module.actions;
    // colunas (mesmas que você já tinha)
    const columns = React.useMemo(
        () => [
            {
                id: 'embalagem',
                header: 'Embalagens do produto',
                columns: [
                    { accessorKey: 'Empresa.nomeFantasia', header: 'Empresa' },
                    { accessorKey: 'Embalagem.descricao', header: 'Descrição' },
                    { accessorKey: 'codigoBarras', header: 'Código de Barras', muiTableBodyCellProps: { align: 'right' } },
                    {
                        accessorKey: 'principal',
                        header: 'Principal',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: { align: 'center' },
                        Cell: ({ row }) => (row.original.principal ? 'Sim' : 'Não'),
                    },
                    {
                        accessorKey: 'aceitaFracao',
                        header: 'Aceita Fração',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: { align: 'center' },
                        Cell: ({ row }) => (row.original.aceitaFracao ? 'Sim' : 'Não'),
                    },
                    {
                        accessorKey: 'ativo',
                        header: 'Ativo',
                        columnFilterModeOptions: ['equals'],
                        filterSelectOptions: [
                            { label: 'Todos', value: '' },
                            { label: 'Sim', value: '1' },
                            { label: 'Não', value: '0' },
                        ],
                        filterVariant: 'select',
                        muiTableBodyCellProps: { align: 'center' },
                        Cell: ({ row }) => (row.original.ativo ? 'Sim' : 'Não'),
                    },
                ],
            },
        ],
        []
    );

    const uiTab = profile.uiTabs.embalagem;

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <SelectEmpresa
                    name="novaEmbalagem.empresaId"
                    text="Empresa"
                    options={OptionsEmpresa}
                    handleOnChange={onChange}
                    value={novaEmbalagem.empresaId}
                    isEnum={false}
                    notOptNull={true}
                />
                <Select
                    name="novaEmbalagem.embalagemId"
                    text="Embalagem"
                    options={OptionsEmbalagem}
                    handleOnChange={onChange}
                    value={novaEmbalagem.embalagemId}
                    isEnum={false}
                    notOptNull={false}
                />
                <Input
                    text={uiTab?.labels?.codigoBarras}
                    type="text"
                    name="novaEmbalagem.codigoBarras"
                    placeholder="Código de Barras"
                    title={uiTab?.titles?.codigoBarras}
                    inputWidth="200px"
                    handleOnChange={onChange}
                    value={novaEmbalagem.codigoBarras || ''}
                    readonly={false}
                />

                <Checkbox
                    title="embalagem padrão do produto"
                    text="Principal"
                    name="novaEmbalagem.principal"
                    handleOnChange={onChange}
                    value={novaEmbalagem.principal}
                    checked={!!novaEmbalagem.principal}
                />

                <Checkbox
                    title="embalagem aceita fracionar no movimento"
                    text="Aceita Fração"
                    name="novaEmbalagem.aceitaFracao"
                    handleOnChange={onChange}
                    value={novaEmbalagem.aceitaFracao}
                    checked={!!novaEmbalagem.aceitaFracao}
                />

                <Checkbox
                    title="Ativo quando marcado"
                    text="Ativo"
                    name="novaEmbalagem.ativo"
                    handleOnChange={onChange}
                    value={novaEmbalagem.ativo}
                    checked={!!novaEmbalagem.ativo}
                />

                <Button variant="contained" color="inherit" onClick={limpar} style={{ marginLeft: '10px' }}>
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(novaEmbalagem.funcao).toLowerCase() === 'deletar' ? 'error' : 'info'}
                    disabled={!isDisabled}
                    onClick={submit}
                    style={{ marginLeft: '5px' }}
                >
                    {novaEmbalagem.funcao}
                </Button>
            </div>

            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: { align: 'center' },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': {
                            enableColumnActions: false,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    <IconButton
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Editar')}
                                        disabled={!podeEditarItem()}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleEditarOuDeletar(row.original, row.index, 'Deletar')}
                                        disabled={!podeCancelarItem()}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={items}
                    rowCount={rowCount}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting: mrt.sorting,
                    }}
                    positionExpandColumn={'first'}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};

export default React.memo(EmbalagensTabPanel);
